<template>
  <div class="jl-about-wrap" v-cloak>
    <div class="about-banner">
      <img class="banner-img" :src="aboutObj.imgUrl" alt />
      <div class="banner-info">
        <div class="jl-container">
          <p class="banner-title">关于我们</p>
        </div>
      </div>
    </div>
    <div class="about-desc">
      <div class="jl-container">
        <p class="text-title">公司简介</p>
        <div v-html="aboutObj.intro"></div>
        <!-- <p class="text-desc">荔虹（上海）观赏鱼养殖有限公司成立于2004年，至今已有15个年头。</p>
        <p class="text">公司位于上海市松江区花卉公路8号，毗邻泖田湿地，交通位置十分便利。</p>
        <p class="text">鱼场占地面积140亩，养殖水泥池近万吨，养殖野池35面，</p>
        <p class="text">与日本最知名的100多家养鲤场建立了良好的合作关系，且鱼场内常年有上万尾鱼，为广大锦鲤爱好者提供充足的选择。</p>-->
      </div>
    </div>
    <div class="about-section-1">
      <ul class="list">
        <li class="item">
          <p class="text1">
            <span class="span-1">{{aboutObj.year}}</span>
            <span class="span-2">年</span>
          </p>
          <p class="text2">公司成立于{{aboutObj.year}}年</p>
        </li>
        <li class="item">
          <p class="text1">
            <span class="span-1">{{aboutObj.yearNum}}</span>
            <span class="span-2">年</span>
          </p>
          <p class="text2">至今已有{{aboutObj.yearNum}}个年头</p>
        </li>
        <li class="item">
          <p class="text1">
            <span class="span-1">{{aboutObj.area}}</span>
            <span class="span-2">亩</span>
          </p>
          <p class="text2">鱼场占地面积{{aboutObj.area}}亩</p>
        </li>
        <li class="item">
          <p class="text1">
            <span class="span-1">{{aboutObj.pool}}</span>
            <span class="span-2">面</span>
          </p>
          <p class="text2">养殖野池{{aboutObj.pool}}面</p>
        </li>

        <li class="item">
          <p class="text1">
            <span class="span-1">{{aboutObj.cooperate}}</span>
            <span class="span-2 active">+</span>
          </p>
          <p class="text2">与日本最知名的{{aboutObj.cooperate}}多家养鲤场 建立了良好的合作关系</p>
        </li>
      </ul>
    </div>
    <div class="about-section-2">
      <div class="jl-container">
        <div class="about-se2-box clearfix">
          <div class="item-left">
            <div class="item-info">
              <p class="text-title">我们的服务</p>
              <div class="text-desc" v-html="aboutObj.server">
                <!-- <p>荔虹锦鲤主营高级锦鲤鱼、有过滤设备及各品牌饲料等一切饲养用品，承接锦鲤池的设计、改造及建造工程，并提供售后饲养技术指导、鱼池维护、锦鲤鱼病防治等相关服务</p>
                <p>我们凭借专业的技术及一流的服务，</p>
                <p>赢得了广大鱼友们的一致好评。</p>-->
              </div>
            </div>
          </div>
          <div class="item-right">
            <img :src="aboutObj.serviceUrl" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAboutDetail } from "@/api/about";
export default {
  name: "aboutIndex",
  data() {
    return {
      aboutObj: {}
    };
  },
  methods: {
    format(value) {
      //为了兼容ie9时间格式
      if (value) {
        var tt = value.replace(/-/g, "/");
        var time = new Date(tt);
        return time;
      } else {
        return "";
      }
    },
    computedYear(time) {
      let _dateYear = new Date(this.format(time)).getFullYear(),
        nowYear = new Date().getFullYear(),
        n = nowYear - _dateYear;
      this.aboutObj.year = _dateYear;
      this.aboutObj.yearNum = n === 0 ? 1 : n;
    },
    getDetail() {
      getAboutDetail(this);
    }
  },
  created() {
    this.getDetail();
  }
};
</script>

<style lang="scss" scoped>
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.about-banner {
  position: relative;
  .banner-img {
    display: block;
    width: 100%;
  }
  .banner-info {
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    margin-top: -30px;
  }
  .banner-title {
    position: relative;
    font-size: 52px;
    color: #fff;
    line-height: 1;
    padding-bottom: 30px;
    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 55px;
      height: 3px;
      background: #fff;
    }
  }
}
.about-desc {
  padding: 44px 0;
  text-align: center;
  .text-title {
    position: relative;
    font-size: 36px;
    color: #333;
    line-height: 1;
    padding-bottom: 24px;
    text-align: center;
    margin-bottom: 15px;
    &::before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      width: 54px;
      height: 4px;
      background: #e50011;
      margin-left: -27px;
    }
  }
  .text-desc {
    font-size: 18px;
    color: #333;
    font-weight: bold;
    line-height: 30px;
  }
  .text {
    font-size: 16px;
    color: #333;
    line-height: 30px;
  }
}
.about-section-1 {
  padding: 100px 0;
  background: url("../../assets/img/zkj-about-bg.jpg") no-repeat center center;
  background-size: cover;
  .list {
    text-align: center;
    .item {
      position: relative;
      display: inline-block;
      vertical-align: middle;
      width: 19%;
      border-right: 1px solid #7b7c7e;
      &:last-child {
        border-right: none;
      }
      .text1 {
        color: #fff;
        margin-bottom: 12px;
        .span-1 {
          font-size: 40px;
        }
        .span-2 {
          font-size: 20px;
          &.active {
            vertical-align: top;
          }
        }
      }
      .text2 {
        font-size: 14px;
        color: #fff;
        width: 72%;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
}
.about-section-2 {
  padding-top: 80px;
  background: #f8f8fb;
  padding-bottom: 120px;
  .about-se2-box {
    background: #fff;
    .item-left {
      float: left;
      width: 50%;
    }
    .item-right {
      float: right;
      width: 50%;
      min-height: 450px;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        transition: all 0.3s;
      }
    }
  }
  .item-info {
    padding-top: 70px;
    .text-title {
      position: relative;
      font-size: 36px;
      color: #333;
      text-align: center;
      padding-bottom: 24px;
      line-height: 1;
      margin-bottom: 15px;
      &::before {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 54px;
        height: 4px;
        background: #e50011;
        margin-left: -27px;
      }
    }
    .text-desc {
      width: 63%;
      margin-left: auto;
      margin-right: auto;
      text-align: center;
      font-size: 16px;
      line-height: 36px;
      color: #666;
    }
  }
}
@media screen and (min-width: 1200px) {
  .about-section-2 .about-se2-box .item-right img:hover {
    transform: scale(1.1);
  }
}
</style>
